import React, {PropTypes} from 'react';
import FontAwesome from 'react-fontawesome';
// import * as utils from './utils';

const Button = (props) => {
  if (props.permission === false) {
    return null;
  }
  return (
    <button className={props.className}
      disabled={props.disabled}
      onClick={props.onClick} >
      {props.faName && <FontAwesome name={props.faName} />}
      {props.children}
    </button>
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
Button.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  faName: PropTypes.string,
  disabled: PropTypes.bool,
  permission: PropTypes.bool,
  children: PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.array,
    React.PropTypes.element,
  ])
};

export default Button;



/** WEBPACK FOOTER **
 ** ./src/components/common/Button.js
 **/